import React from "react";
import { IconStyle } from "../../types/enums/IconStyles";
import { ContextMenuContextType } from "./ContextMenuContext";

interface ContextMenuItemProps {
    id: string;
    icon?: string;
    iconStyle?: IconStyle;
    name?: string;
    disabled?: boolean;
    shortcut?: string;
    contextKey?: string;
    separator?: boolean;
    order?: number;
    hideHandler?: (context: ContextMenuContextType) => boolean;
    disabledHandler?: (context: ContextMenuContextType) => boolean;
    handler?: (
        event: React.MouseEvent | React.KeyboardEvent,
        context: ContextMenuContextType,
    ) => void;
}

class ContextMenuItem extends React.Component<ContextMenuItemProps> {
    id: string;
    icon?: string;
    iconStyle?: IconStyle;
    name?: string;
    disabled?: boolean;
    shortcut?: string;
    contextKey?: string;
    separator?: boolean;
    order?: number;
    hideHandler?: (context: ContextMenuContextType) => boolean;
    disabledHandler?: (context: ContextMenuContextType) => boolean;
    handler?: (
        event: React.MouseEvent | React.KeyboardEvent,
        context: ContextMenuContextType,
    ) => void;

    render() {
        return null;
    }
}

export default ContextMenuItem;
